// from http://daringfireball.net/2010/07/improved_regex_for_matching_urls
const regex =
    /\b(?:(?:https?:\/\/|www\d{0,3}[.]|[a-z0-9.-]+[.][a-z]{2,4}\/)(?:[^\s()<>&]+|&amp;|\((?:[^\s()<>]|(?:\([^\s()<>]+\)))*\))+(?:\((?:[^\s()<>]|(?:\([^\s()<>]+\)))*\)|[^\s`!()[\]{};:'".,<>?«»“”‘’&]))/gi;

export default function autolink(text: string, nofollow?: boolean): string {
    return text.replace(regex, function (url) {
        if (!/^https?:\/\//.test(url)) {
            url = "http://" + url;
        }

        const nofollowAttr = nofollow ? 'rel="nofollow"' : "";

        return "<a " + nofollowAttr + ' href="' + url + '">' + url + "</a>";
    });
}
